import React from 'react';
import { images } from '../data/content';
export function Hero() {
  return <section className="mx-auto max-w-[680px] px-6 pb-4 pt-10" data-id="element-91" data-mp="ejwfyzd2ht1i">
      <h1 className="text-center font-display text-[29px] font-semibold leading-[1.28] tracking-[-0.015em] text-ink-900" data-id="element-92" data-mp="eilh9dyhbbh9">
        With just <span className="text-ink-700" data-id="element-93" data-mp="4lqf8l2zysy8">10 minutes a day</span>, your child{' '}
        <span className="text-forest-600" data-id="element-94" data-mp="4jm7fs1z99so">puts the phone down</span> and starts creating with their
        own hands with <span className="accent-underline text-gold-500" data-id="element-95" data-mp="xae8p3xwgomv">+120 clever projects</span>.
      </h1>

      <div className="mt-8" data-id="element-96" data-mp="sbb2hg66ocdb">
        <img src={images.heroTablets} alt="The six Little Engineers digital books shown on tablets, with sample activity pages above and finished cardboard projects below" className="mx-auto block h-auto w-full max-w-[632px] object-contain" width={1536} height={1024} loading="eager" fetchPriority="high" decoding="sync" data-id="element-97" data-mp="sai4p4p7cx7b" />
      </div>
    </section>;
}